/**
 * Client HTTP.
 *
 * Unico punto in cui si parla con l'API. Due responsabilita oltre alla
 * chiamata: riconoscere gli errori di dominio del timer, che portano un
 * `motivo` leggibile, e confrontare la versione della build.
 */

export class ErroreApi extends Error {
  constructor(
    message: string,
    readonly stato: number,
    readonly motivo?: string,
    readonly corpo?: unknown,
  ) {
    super(message);
  }
}

/** Versione del server vista nell'ultima risposta. */
let versioneServer: string | null = null;
const ascoltatori = new Set<(disallineata: boolean) => void>();

export const versioneDisallineata = (): boolean =>
  versioneServer !== null &&
  import.meta.env.VITE_APP_VERSION !== undefined &&
  versioneServer !== import.meta.env.VITE_APP_VERSION;

export function osservaVersione(fn: (disallineata: boolean) => void): () => void {
  ascoltatori.add(fn);
  return () => ascoltatori.delete(fn);
}

export async function chiama<T>(
  percorso: string,
  opzioni: { metodo?: string; corpo?: unknown; segnale?: AbortSignal } = {},
): Promise<T> {
  const risposta = await fetch(`/api${percorso}`, {
    method: opzioni.metodo ?? 'GET',
    headers: opzioni.corpo ? { 'content-type': 'application/json' } : undefined,
    body: opzioni.corpo ? JSON.stringify(opzioni.corpo) : undefined,
    credentials: 'same-origin',
    signal: opzioni.segnale,
  });

  const versione = risposta.headers.get('x-app-version');
  if (versione && versione !== versioneServer) {
    versioneServer = versione;
    // Mai ricaricare da soli: interrompere una partita per applicare un
    // aggiornamento sarebbe il peggior comportamento possibile. Si avvisa e
    // basta, e chi sta registrando decide quando.
    for (const fn of ascoltatori) fn(versioneDisallineata());
  }

  if (!risposta.ok) {
    const corpo = await risposta.json().catch(() => ({}));
    throw new ErroreApi(
      (corpo as { errore?: string }).errore ?? 'Richiesta non riuscita.',
      risposta.status,
      (corpo as { motivo?: string }).motivo,
      corpo,
    );
  }

  if (risposta.status === 204) return undefined as T;
  const testo = await risposta.text();
  return (testo ? JSON.parse(testo) : undefined) as T;
}
